<template>
    <v-card tile>
        <v-card-title class="justify-center">
            Llena tus datos
        </v-card-title>
        <v-card-text class="pa-0" ref="stepRef" id="content_purchase">
            <div class="pa-0">
                <v-form @submit.prevent="lastStep" ref="valLast" lazy-validation>
                    <v-card tile elevation="0">
                        <v-card-text class="pa-0">
                            <v-card-title class="py-3 blue-grey lighten-5">
                                Forma de entrega
                            </v-card-title>
                            <div class="px-3">
                                <v-radio-group
                                    v-model="deliveryMethod"
                                    row
                                >
                                    <v-radio
                                        v-if="delivery.enable"
                                        label="Delivery"
                                        value="delivery"
                                        :color="btnColor"
                                    ></v-radio>
                                    <v-radio
                                        v-if="listAddressOfPickUp.length>0"
                                        label="Recojo"
                                        value="i_pick_up"
                                        :color="btnColor"
                                    ></v-radio>
                                    <v-radio
                                        v-if="enableTable"
                                        label="Pedido para la mesa"
                                        value="order_table"
                                        :color="btnColor"
                                    ></v-radio>
                                    <v-radio
                                        v-if="eatLocal.enable"
                                        value="eat_local"
                                        :color="btnColor"
                                    >
                                        <template v-slot:label>
                                            <span>
                                                Comer en nuestro local.
                                                <span style="color:#ff0000" v-if="eatLocal.value>0"> AHORRA {{ money }} {{ ((total-valCoupon)>0)?( ((total-valCoupon)*eatLocal.value)/100 ).toFixed(0):0 }}</span>
                                            </span>
                                        </template>
                                    </v-radio>
                                </v-radio-group>
                            </div>
                            <v-card-title class="py-3 blue-grey lighten-5" v-if="deliveryMethod!='order_table'">
                                Recibir la orden
                            </v-card-title>
                            <div class="px-3" v-if="deliveryMethod!='order_table'">
                                <v-radio-group
                                    v-model="receiveOrder"
                                    row
                                    :rules="[rules.required]"
                                >
                                    <v-radio
                                        label="Ahora mismo"
                                        value="right_now"
                                        :color="btnColor"
                                        v-if="!closedStore"
                                    ></v-radio>
                                    <v-radio
                                        label="Programar entrega"
                                        value="schedule_delivery"
                                        v-if="!closedStore"
                                        :color="btnColor"
                                    ></v-radio>
                                </v-radio-group>
                                <v-row v-if="receiveOrder == 'schedule_delivery'">
                                    <v-col cols="12" class="py-0">Programar entrega, día y hora</v-col>
                                    <v-col cols="6">
                                        <v-menu
                                            v-model="menu1"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="auto"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    v-model="orderDay"
                                                    label="Día"
                                                    prepend-icon="mdi-calendar"
                                                    outlined
                                                    dense
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    :rules="[rules.required]"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-model="orderDay"
                                                @input="menu1 = false"
                                                :color="btnColor"
                                                locale="es-bo"
                                                class="ma-0"
                                            ></v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="6" v-if="orderProgram">
                                        <v-menu
                                            ref="menu"
                                            v-model="menu2"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            :return-value.sync="orderTime"
                                            transition="scale-transition"
                                            offset-y
                                            max-width="290px"
                                            min-width="290px"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    v-model="orderTime"
                                                    label="Hora"
                                                    prepend-icon="mdi-clock-time-four-outline"
                                                    outlined
                                                    dense
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    :rules="[rules.required]"
                                                ></v-text-field>
                                            </template>
                                            <v-time-picker
                                                v-if="menu2"
                                                v-model="orderTime"
                                                full-width
                                                @click:minute="$refs.menu.save(orderTime)"
                                                :color="btnColor"
                                                locale="es-bo"
                                                class="ma-0"
                                                :allowed-minutes="(m) => m % 15 === 0"
                                            ></v-time-picker>
                                        </v-menu>
                                    </v-col>
                                </v-row>
                            </div>
                            <v-card-title class="py-3 blue-grey lighten-5" v-if="deliveryMethod=='delivery'">
                                Dirección de entrega &nbsp;<small> (Precio del delivery: {{ (tempPrice<=0)?'por confirmar':tempPrice+' '+money }})</small>
                                <div v-if="tempCommentDelivery != ''" class="py-2">
                                    <v-alert
                                        dense
                                        outlined
                                        text
                                        type="info"
                                        class="mb-0 body-2"
                                    >{{ tempCommentDelivery }}</v-alert>
                                </div>
                            </v-card-title>
                            <google-map
                                v-if="showMap && deliveryMethod=='delivery'"
                                :center="{lat: tmpLat, lng: tmpLng}"
                                :zoom="13"
                                :btn-color="btnColor"
                                @result-click="resultClickMap"
                            ></google-map>
                            <div class="pa-3" v-if="deliveryMethod=='delivery'">
                                <p>La tarifa de entrega por el delivery se cancela en efectivo al repartidor</p>
                                <v-text-field
                                    label="Dirección de entrega *"
                                    :color="btnColor"
                                    outlined
                                    dense
                                    v-model="deliveryAddress"
                                    :rules="[rules.required]"
                                ></v-text-field>
                                <v-textarea
                                    label="Aclaración de dirección"
                                    placeholder="Ejm. Casa rojo con puerta de metal"
                                    outlined
                                    :color="btnColor"
                                    rows="3"
                                    v-model="addressClarification"
                                ></v-textarea>
                            </div>

                            <v-card-title class="py-3 blue-grey lighten-5" v-if="deliveryMethod=='i_pick_up'">
                                Dirección de recojo
                            </v-card-title>
                            <div class="pa-3" v-if="deliveryMethod=='i_pick_up'">
                                <v-radio-group v-model="addressOfPickUp">
                                    <v-radio
                                        v-for="(addr, j) in listAddressOfPickUp" :key="j"
                                        :label="addr.address"
                                        :value="(addr.map!='')?addr.map:addr.address"
                                        :color="btnColor"
                                    ></v-radio>
                                </v-radio-group>
                            </div>
                            
                            <v-card-title class="py-3 blue-grey lighten-5">
                                Mis datos
                            </v-card-title>
                            <div class="pa-3">
                                <v-row>
                                    <v-col cols="6">
                                        <v-text-field
                                            label="Nombre completo *"
                                            :color="btnColor"
                                            outlined
                                            dense
                                            v-model="fullName"
                                            :rules="[rules.required]"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="6">
                                        <!-- <v-text-field
                                            label="Número de celular *"
                                            :color="btnColor"
                                            outlined
                                            dense
                                            v-model="phoneNumber"
                                            type="number"
                                            :rules="[rules.required, rules.min]"
                                        ></v-text-field> -->
                                        <vue-tel-input-vuetify
                                            label="Número de celular *"
                                            :color="btnColor"
                                            outlined
                                            dense
                                            :defaultCountry="iso2"
                                            :onlyCountries="[iso2]"
                                            :rules="[rules.required]"
                                            :value="tmpPhone"
                                            @input="onInput"
                                        ></vue-tel-input-vuetify>
                                    </v-col>
                                </v-row>
                            </div>
                            <v-card-title class="py-3 blue-grey lighten-5">
                                Método de pago
                            </v-card-title>
                            <div class="pa-3">
                                <v-radio-group
                                    v-model="paymentMethod"
                                    row
                                >
                                    <v-radio
                                        v-if="enableUponDelivery"
                                        label="Pago Contraentrega"
                                        value="cash_payment"
                                        :color="btnColor"
                                    ></v-radio>
                                    <v-radio
                                        v-if="enablePaymentMethod"
                                        label="Pago Qr/Transferencia Bancaria"
                                        value="bank_payment"
                                        :color="btnColor"
                                    ></v-radio>
                                    <v-radio
                                        v-if="enablePaymentCard"
                                        label="Pago tarjeta de débito/crédito"
                                        value="card_payment"
                                        :color="btnColor"
                                    ></v-radio>
                                    <v-radio
                                        v-if="enableVeMethod && iso2=='VE'"
                                        label="Pago por PagomóvilBDV"
                                        value="bank_ven"
                                        :color="btnColor"
                                    ></v-radio>
                                </v-radio-group>
                                <div v-if="paymentMethod == 'bank_payment'" class="text-center">
                                    <v-img
                                        :src="codePaymentMethod"
                                        max-width="300px"
                                        class="mx-auto mb-2"
                                    ></v-img>
                                    <!-- <a :href="codePaymentMethod" download :style="`color: ${btnColor}`">Descargar QR</a> -->
                                    <v-btn
                                        :href="codePaymentMethod"
                                        download
                                        :color="btnColor"
                                        dark
                                        small
                                        class="mb-2"
                                    >
                                        Descargar QR
                                    </v-btn>
                                    <p class="mb-0">Banco: {{ payment.bank }}</p>
                                    <p class="mb-0">Cuenta: {{ payment.account }}</p>
                                    <p class="mb-0">Nombre: {{ payment.name }}</p>
                                    <p class="mb-10">NIT: {{ payment.nit }}</p>
                                </div>
                                <div v-if="paymentMethod == 'bank_ven'" class="text-center">
                                    <v-img
                                        :src="venPaymentMethod"
                                        max-width="300px"
                                        class="mx-auto mb-2"
                                    ></v-img>
                                    <p class="mb-0">Banco: {{ payment2.bank }}</p>
                                    <p class="mb-0">Documento: {{ payment2.document }}</p>
                                    <p class="mb-0">Nombre: {{ payment2.name }}</p>
                                    <p class="mb-10">Tel: {{ payment2.tel }}</p>
                                </div>
                            </div>
                            <v-card-title class="py-3 blue-grey lighten-5">
                                Resumen de orden
                            </v-card-title>
                            <div class="pa-3">
                                <v-simple-table dense class="mb-5">
                                    <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th class="text-left grey--text text--lighten-1">
                                                Cantidad
                                            </th>
                                            <th class="text-left grey--text text--lighten-1">
                                                Producto
                                            </th>
                                            <th class="text-right grey--text text--lighten-1">
                                                Precio
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, i) in cart" :key="i">
                                            <td class="text-left">{{ item.quantity }}x</td>
                                            <td class="text-left">{{ item.name }}</td>
                                            <td class="text-right">{{ money }} {{ (item.priceNormal<0) ? item.price : item.priceNormal }}</td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td>
                                                <strong style="font-size: 1.1rem;">Subtotal</strong>
                                            </td>
                                            <td colspan="2" class="text-right">
                                                <!-- <strong class="text-h6" v-if="deliveryMethod=='delivery'">{{ total+(+tempPrice) }} {{ money }}</strong> -->
                                                <strong style="font-size: 1.1rem;">{{ money }} {{ total }}</strong>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <strong style="font-size: 1.1rem;">Descuento</strong>
                                            </td>
                                            <td colspan="2" class="text-right">
                                                <!-- <strong class="text-h6" v-if="deliveryMethod=='delivery'">{{ total+(+tempPrice) }} {{ money }}</strong> -->
                                                <strong style="font-size: 1.1rem;">-{{ money }} {{ discountProds }}</strong>
                                            </td>
                                        </tr>
                                        <tr v-if="deliveryMethod=='delivery'">
                                            <td>
                                                <strong style="font-size: 1.1rem;">Delivery</strong>
                                            </td>
                                            <td colspan="2" class="text-right">
                                                <strong style="font-size: 1.1rem;">+{{ money }} {{ (tempPrice<=0)?'Por Confirmar':tempPrice }}</strong>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <strong style="font-size: 1.1rem;">Cupón</strong>
                                            </td>
                                            <td colspan="2" class="text-right">
                                                <strong style="font-size: 1.1rem;">-{{ money }} {{ valCoupon }}</strong>
                                            </td>
                                        </tr>
                                        <tr v-if="eatLocal.enable && deliveryMethod=='eat_local'">
                                            <td>
                                                <strong style="font-size: 1.1rem;">Desc. comer en local</strong>
                                            </td>
                                            <td colspan="2" class="text-right">
                                                <strong style="font-size: 1.1rem;">-{{ money }} {{ ((total-valCoupon)>0)?( ((total-valCoupon)*eatLocal.value)/100 ).toFixed(0):0 }}</strong>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <strong style="font-size: 1.4rem;">Total</strong>
                                            </td>
                                            <td colspan="2" class="text-right">
                                                <strong style="font-size: 1.4rem;" v-if="deliveryMethod=='delivery'">{{ money }} {{ (((total- (valCoupon+discountProds) )>0)?(total- (valCoupon+discountProds) ):0)+(+tempPrice) }}</strong>
                                                <strong style="font-size: 1.4rem;" v-else>{{ money }} {{ ((total- (valCoupon+discountProds) )>0)?( (total- (valCoupon+discountProds) ) - (( ((total- (valCoupon+discountProds) )*((deliveryMethod=='eat_local')?eatLocal.value:0))/100 ).toFixed(0)) ):0 }}</strong>
                                            </td>
                                        </tr>
                                    </tfoot>
                                    </template>
                                </v-simple-table>
                                <!--  -->
                                <div class="mb-3" v-if="deliveryMethod=='delivery'">
                                    <h4>El pedido será enviado a:</h4> {{ address }}
                                    <p>La tarifa de entrega por el delivery se cancela en efectivo al repartidor.</p>
                                </div>
                                <div class="mb-3" v-if="deliveryMethod=='i_pick_up'">
                                    <h4>Dirección del negocio:</h4> Direccion de la tienda
                                </div>

                                <v-checkbox
                                    v-model="remarkOrder"
                                    :color="btnColor"
                                    label="Incluir un comentario para la orden"
                                    hide-details
                                ></v-checkbox>
                                <!-- commentOrder -->
                                <v-textarea
                                    placeholder="Ejm. Si es posible un poco de sal extra por favor."
                                    outlined
                                    :color="btnColor"
                                    rows="3"
                                    v-model="commentOrder"
                                    v-if="remarkOrder"
                                    :rules="[rules.required]"
                                ></v-textarea>

                                <!-- create account -->
                                <template v-if="funLogin">
                                    <div v-if="JSON.stringify(this.lastPurchase) == '{}'">
                                        <v-checkbox
                                            v-model="createAccount"
                                            :color="btnColor"
                                            label="¿Crear cuenta?"
                                            hide-details
                                        ></v-checkbox>
                                        <v-alert
                                            dense
                                            border="left"
                                            color="grey lighten-3"
                                            v-if="createAccount"
                                        >
                                            Recuerde que tu usuario es tu número de celular
                                            <v-text-field
                                                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                                :type="show1 ? 'text' : 'password'"
                                                label="Contraseña *"
                                                hint="Mínimo 8 caracteres"
                                                counter
                                                dense
                                                outlined
                                                :color="btnColor"
                                                class="mt-2"
                                                :rules="[rules.required, rules.min]"
                                                @click:append="show1 = !show1"
                                                v-model="password"
                                            ></v-text-field>
                                        </v-alert>
                                    </div>
                                </template>
                            </div>
                            <v-card-title class="py-3 blue-grey lighten-5" v-if="enableInvoice">
                                Datos de facturación
                            </v-card-title>
                            <div class="pa-3" v-if="enableInvoice">
                                <!-- invoice -->
                                <v-text-field
                                    label="Razón social"
                                    :color="btnColor"
                                    outlined
                                    dense
                                    v-model="businessName"
                                    v-if="enableInvoice"
                                ></v-text-field>
                                <!--  :rules="[rules.required]" -->
                                <v-text-field
                                    label="NIT / CI"
                                    :color="btnColor"
                                    outlined
                                    dense
                                    v-model="document"
                                    v-if="enableInvoice"
                                ></v-text-field>
                                <!-- :rules="[rules.required]" -->
                            </div>
                        </v-card-text>

                        <!-- overlay -->
                        <v-overlay :value="loading" absolute opacity=".9" z-index="10">
                            <v-progress-circular
                                indeterminate
                                size="64"
                                :color="btnColor"
                            ></v-progress-circular>
                        </v-overlay>
                        <!-- end overlay -->
                    </v-card>
                </v-form>
            </div>
        </v-card-text>

        <v-card-actions class="pa-actions">
            <v-row>
                <v-col cols="4">
                    <v-btn
                        large
                        text
                        :color="btnColor"
                        rounded
                        block
                        @click="$emit('close-purchase')"
                    >
                        Atrás
                    </v-btn>
                </v-col>
                <v-col cols="8" v-if="tempMode=='order_generate'">
                    <v-btn
                        large
                        rounded
                        :color="btnColor"
                        :style="`color:${textbtnColor}`"
                        class="mb-2"
                        type="submit"
                        block
                        :loading="loading"
                        @click="openPreviewOrder"
                    >Confirmar pedido</v-btn>
                </v-col>
                <v-col cols="8" v-else>
                    <v-btn
                        large
                        rounded
                        :color="btnColor"
                        :style="`color:${textbtnColor}`"
                        class="mb-2"
                        type="submit"
                        @click="lastStep"
                        block
                        :loading="loading"
                    >
                        Confirmar pedido
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-actions>

        <v-dialog
            v-model="dialogGenerate"
            width="500"
            scrollable
            :fullscreen="$vuetify.breakpoint.smAndDown"
            transition="dialog-bottom-transition"
        >
            <v-card>
                <v-card-title>
                    Vista previa del pedido
                </v-card-title>
                <v-card-text>
                    <div style="white-space: break-spaces;" v-html="contentOrder"></div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        rounded
                        large
                        text
                        color="error"
                        class="text-capitalize"
                        @click="dialogGenerate=false"
                    >Volver</v-btn>
                    <v-btn
                        dark
                        large
                        rounded
                        color="#43bf51"
                        class="text-capitalize"
                        @click="sendOrderWhatsApp"
                    >
                        <v-icon left>
                            mdi-whatsapp
                        </v-icon>
                        Enviar pedido
                    </v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>
<script>
import VueTelInputVuetify from 'vue-tel-input-vuetify/lib/vue-tel-input-vuetify.vue';
// Vue.use(VueTelInputVuetify);
    export default {
        components: {
            VueTelInputVuetify,
        },
        data () {
            return {
                loading: false,
                e1: 1,
                menu1: false,
                menu2: false,
                //
                deliveryMethod: 'delivery',
                delivery: {
                    enable: false,
                    value: null,
                    type: ''
                },
                eatLocal: {
                    enable: false,
                    value: 0,
                },
                receiveOrder: 'right_now',
                orderDay: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
                // orderDay: null,
                orderTime: '00:00',
                deliveryAddress: '',
                addressClarification: '',
                listAddressOfPickUp: [],
                addressOfPickUp: '',
                fullName: '',
                tmpPhone: '',
                phoneCode: '',
                phoneValid: false,
                phoneNumber: '',
                enablePaymentMethod: false,
                enablePaymentCard: false,
                enableUponDelivery: false,
                codePaymentMethod: '',
                paymentMethod: 'cash_payment',
                payment: {
                    bank: '',
                    account: '',
                    name: '',
                    nit: ''
                },
                enableVeMethod: false,
                venPaymentMethod: '',
                payment2: {
                    bank: '',
                    document: '',
                    name: '',
                    tel: ''
                },
                previewCode: '',
                proofPayment: null,
                remarkOrder: false,
                commentOrder: '',
                // invoice
                enableInvoice: false,
                businessName: '',
                document: '',
                // order table
                enableTable: false,
                // map
                showMap: false,
                address: '',
                lat: null,
                lng: null,
                tmpLat: -17.3751345,
                tmpLng: -66.1844502,
                // cart
                cart: {},
                tempPrice: 0,
                tempCommentDelivery: '',
                total: 0,
                // validation
                errorImg: false,
                rules: {
                    required: v => !!v || 'El campo es requerido',
                    min: v => v.length >= 8 || 'Mínimo 8 caracteres',
                    phone: v => (v.length >= 8 && v.length <= 8) || 'Debe contener 8 dígitos',
                    email: v => /.+@.+\..+/.test(v) || 'Correo electrónico inválido'
                },
                // create account
                createAccount: false,
                show1: false,
                password: '',
                // wsp order
                dialogGenerate: false,
                contentOrder: '',
                // order ´program
                orderProgram: true
            }
        },
        props: [
            'slug',
            'titleColor',
            'btnColor',
            'textbtnColor',
            'bannerColor',
            'textnavColor',
            'navColor',
            'dataMyStore',
            'fontFamily',
            'upCart',
            'lastPurchase',
            'closedStore',
            'money',
            'tempMode',
            'iso2',
            'valCoupon',
            'discountProds',
            'nameCoupon',
            'funLogin',
            'fidelyPoints',
            'fidelyPointsValue',
            'fidelyPointsUrl',
            'isDomain'
        ],
        watch: {
            upCart(newVal, oldVal) { // watch it
                // console.log('Prop changed: ', newVal, ' | was: ', oldVal)
                this.updateCart()
                this.e1 = 1
            }
        },
        mounted() {
            this.getMainData()

            this.updateCart()

            if (JSON.stringify(this.lastPurchase) != '{}') {
                this.fullName = this.lastPurchase.full_name
                this.phoneCode = this.lastPurchase.code
                this.phoneNumber = this.lastPurchase.phone_number
                this.tmpPhone = this.phoneCode + this.phoneNumber
                this.deliveryMethod = this.lastPurchase.delivery_method
                this.tmpLat = (this.lastPurchase.lat_map)?+this.lastPurchase.lat_map:-17.3751345
                this.tmpLng = (this.lastPurchase.lng_map)?+this.lastPurchase.lng_map:-66.1844502
                this.deliveryAddress = this.lastPurchase.delivery_address
                this.addressClarification = this.lastPurchase.address_clarification

                this.showMap = true
            }
            else this.getLocation()

            if (this.closedStore) this.receiveOrder = 'schedule_delivery'
        },
        methods: {
            onInput(formattedNumber, { number, valid, country }) {
                this.phoneCode = '+'+country.dialCode
                this.phoneNumber = number.significant
                this.tmpPhone = number.international
                this.phoneValid = valid
            },
            /**
             * upload cart
             */
            updateCart(){
                if (localStorage.getItem(this.slug)) {
                    this.cart = JSON.parse(localStorage.getItem(this.slug))
                    this.calculateTotal()
                }
            },
            /**
             * get data
             */
            async getMainData() {
                await axios.get(`/data-order/${this.slug}`)
                .then((response) => {
                    // console.log(response)
                    if (response.data[0]) {
                        const contentPayment = JSON.parse(response.data[0].content)
                        this.enablePaymentMethod = (contentPayment.enable)?true:false
                        this.codePaymentMethod = contentPayment.codeQr
                        this.payment.bank = contentPayment.bank
                        this.payment.account = contentPayment.account
                        this.payment.name = contentPayment.name
                        this.payment.nit = contentPayment.nit
                    }
                    if (response.data[1]) {
                        const contentAddress = JSON.parse(response.data[1].content)
                        if (contentAddress.length > 0) {
                            this.addressOfPickUp = contentAddress[0]
                            this.listAddressOfPickUp = contentAddress
                        }
                    }
                    if (response.data[2]) {
                        const contentCard = JSON.parse(response.data[2].content)
                        this.enablePaymentCard = (contentCard.enable)?true:false
                    }
                    if (response.data[3]) {
                        const contentDelivery = JSON.parse(response.data[3].content)
                        this.delivery.enable = (contentDelivery.enable)?true:false
                        this.delivery.value = contentDelivery.price
                        this.delivery.type = (contentDelivery.type)?contentDelivery.type:'only_price'
                        this.delivery.range = contentDelivery.range ?? []
                        if(!contentDelivery.enable) this.deliveryMethod = 'i_pick_up'
                    } else this.deliveryMethod = 'i_pick_up'
                    if (response.data[5]) {
                        const contentUponDelivery = JSON.parse(response.data[5].content)
                        this.enableUponDelivery = (contentUponDelivery.enable)?true:false
                    }
                    if (response.data[6]) {
                        const contentInvoice = JSON.parse(response.data[6].content)
                        this.enableInvoice = (contentInvoice.enable)?true:false
                    }
                    if (response.data[7]) {
                        const contentTable = JSON.parse(response.data[7].content)
                        this.enableTable = (contentTable.enable)?true:false
                    }
                    if (this.enableUponDelivery) this.paymentMethod = 'cash_payment'
                    if (this.enablePaymentMethod) this.paymentMethod = 'bank_payment'
                    if (this.enablePaymentCard) this.paymentMethod = 'card_payment'

                    if (response.data[11]) {
                        const contentEatLocal = JSON.parse(response.data[11].content)
                        this.eatLocal.enable = (contentEatLocal.enable)?true:false
                        this.eatLocal.value = this.eatLocal.enable ? contentEatLocal.price : 0
                    }

                    if (response.data[13]) {
                        const contentProgram = JSON.parse(response.data[13].content)
                        this.orderProgram = (contentProgram.enable)?true:false
                    }
                    if (response.data[14]) {
                        const contentPayment = JSON.parse(response.data[14].content)
                        this.enableVeMethod = (contentPayment.enable)?true:false
                        this.venPaymentMethod = contentPayment.imgBank
                        this.payment2.bank = contentPayment.bank
                        this.payment2.document = contentPayment.document
                        this.payment2.name = contentPayment.name
                        this.payment2.tel = contentPayment.tel
                    }
                })
                .catch((error) => {
                    // console.log(error)
                    if (error.response.status == 404 || error.response.status == 500) {
                        this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                    }
                })
            },

            /**
             * get location
             */
            getLocation() {
                window.navigator.geolocation.getCurrentPosition(
                    (pos)=>{
                        var crd = pos.coords;
                        this.tmpLat = +crd.latitude
                        this.tmpLng = +crd.longitude
                        this.showMap = true
                    },
                    (err)=>{
                        console.warn('ERROR(' + err.code + '): ' + err.message)
                        this.showMap = true
                    },
                    {
                        enableHighAccuracy: true,
                        timeout: 5000,
                        maximumAge: 0
                    });
            },
            resultClickMap(location) {
                // console.log(location);
                this.address = location.address
                this.lat = location.lat
                this.lng = location.lng
                this.tempCommentDelivery = ''
                if (this.delivery.type == 'km_price') {
                    this.calculatePrice(this.lat, this.lng)
                } if (this.delivery.type == 'range_price') {
                    this.calculatePriceByRange(this.lat, this.lng)
                } else {
                    this.tempPrice = (this.delivery.value)?this.delivery.value:0
                }
                // this.resultMap = location
            },
            async calculatePrice(lat, lng) {
                await axios.post(`/calculate-price/${this.slug}`, {lat:lat, lng:lng})
                .then((response) => {
                    // console.log(response)
                    this.tempPrice = response.data
                })
                .catch((error) => {
                    console.log(error)
                    this.tempPrice = (this.delivery.value)?this.delivery.value:0
                })
            },
            async calculatePriceByRange(lat, lng) {
                await axios.post(`/calculate-price2/${this.slug}`, {lat:lat, lng:lng})
                .then((response) => {
                    // console.log(response)
                    this.tempPrice = response.data.price
                    this.tempCommentDelivery = response.data.comment
                })
                .catch((error) => {
                    console.log(error)
                    this.tempPrice = (this.delivery.value)?this.delivery.value:0
                })
            },
            /**
             * Preview banner
             */
            openInputFile() {
                this.$refs.fileInput.click();
            },
            upBanner(event) {
                const file = event.target.files[0]
                this.previewCode = URL.createObjectURL(file)
                this.proofPayment = file
            },
            /**
             * calculate total
             */
            calculateTotal() {
                this.total = 0
                Object.keys(this.cart).forEach(key => {
                    this.total += ((this.cart[key].priceNormal>0)?this.cart[key].priceNormal:this.cart[key].price);
                });
            },

            /**
             * send data
             */
            async lastStep() {
                if (!this.phoneValid) {
                    this.$alert('Número de celular inválido.')
                    return
                }
                this.errorImg = false
                if (this.$refs.valLast.validate()) {
                    // if (this.paymentMethod == 'bank_payment') {
                    //     if (!this.proofPayment) {
                    //         this.$notify.error('Comprobante obligatorio')
                    //         this.errorImg = true
                    //         return
                    //     }
                    // }
                    this.loading = true
                    // send data
                    const dataForm = new FormData()
                    dataForm.append('store', this.slug)
                    // forma de pago
                    dataForm.append('delivery_method', this.deliveryMethod)
                    dataForm.append('address_map', this.address)
                    dataForm.append('lat_map', this.lat??'')
                    dataForm.append('lng_map', this.lng??'')
                    dataForm.append('delivery_address', this.deliveryAddress)
                    dataForm.append('address_clarification', this.addressClarification)
                    dataForm.append('address_of_pickUp', this.addressOfPickUp)
                    // recibir la orden
                    dataForm.append('receive_order', this.receiveOrder)
                    dataForm.append('order_day', (this.orderDay)??'')
                    dataForm.append('order_time', (this.orderTime)??'')
                    // datos personales
                    dataForm.append('full_name', this.fullName)
                    dataForm.append('phone_number', this.phoneNumber)
                    dataForm.append('code', this.phoneCode)
                    // metodo de pago
                    dataForm.append('payment_method', this.paymentMethod)
                    dataForm.append('proof_payment', this.proofPayment)
                    // resumen de orden
                    dataForm.append('remark_order', (this.remarkOrder)?1:0)
                    dataForm.append('comment_order', this.commentOrder)
                    // carrito
                    dataForm.append('cart', JSON.stringify(this.cart))
                    if (this.deliveryMethod=='delivery') dataForm.append('total', this.total+(+this.tempPrice))
                    else dataForm.append('total', this.total)
                    // account
                    dataForm.append('create_account', this.createAccount?1:0)
                    dataForm.append('password', this.password)
                    // invoice
                    dataForm.append('business_name', this.businessName)
                    dataForm.append('document', this.document)
                    // order whatsapp
                    dataForm.append('wsp_order', this.contentOrder)
                    // discount
                    dataForm.append('discount', (this.valCoupon+this.discountProds))
                    dataForm.append('coupon', this.nameCoupon)
                    // eat local
                    dataForm.append('eat_local', (this.eatLocal.enable && this.deliveryMethod=='eat_local') ? (+(( (this.total-(this.valCoupon+this.discountProds)) *this.eatLocal.value)/100).toFixed(0)) : 0 )

                    await axios.post('/send-order', dataForm)
                    .then((response) => {
                         console.log(response.data)

                         //return;
                        switch (response.data) {
                            case 'ok':
                                this.$fire({
                                    title: 'Pedido realizado con éxito.',
                                    text: 'Su pedido fue realizado con éxito, en un momento recibirá un mensaje de whatsapp para coordinar la entraga y/o recojo.',
                                    type: 'success',
                                    confirmButtonText: 'Continuar',
                                    confirmButtonColor: this.btnColor,
                                    reverseButtons: true,
                                    showCancelButton: false,
                                    customClass: {
                                        container: this.fontFamily
                                    }
                                }).then(resp => {
                                    if (resp.value) {
                                        window.location.href='/'+this.slug
                                    }
                                })

                                this.clearData()
                                break;
                            case 'preview':
                                this.$fire({
                                    title: 'Pedido realizado con éxito.',
                                    text: 'Su pedido fue realizado con éxito, en un momento recibirá un mensaje de whatsapp para coordinar la entraga y/o recojo.',
                                    type: 'success',
                                    confirmButtonText: 'Continuar',
                                    confirmButtonColor: this.btnColor,
                                    reverseButtons: true,
                                    showCancelButton: false,
                                    customClass: {
                                        container: this.fontFamily
                                    }
                                }).then(resp => {
                                    if (resp.value) {
                                        window.location.href='/'+this.slug
                                    }
                                })

                                this.clearData()
                                break;
                            default:
                                this.clearData()
                                if (this.isDomain) {
                                    // abrir en otra ventana
                                    window.open(response.data, '_blank');
                                } else {
                                    //window.location.href = response.data
                                    var link = document.createElement('a');
                                    link.setAttribute('title', 'link');
                                    link.setAttribute('href', response.data);
                                    //link.setAttribute('target', "_blank");
                                    link.click();
                                }
                                break;
                        }
                        this.loading = false
                        localStorage.removeItem(`${this.slug}-coupon`)
                    })
                    .catch((error) => {
                        //console.log(error)
                        if (error.response.status == 404 || error.response.status == 500) {
                            this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                        }
                        this.loading = false
                    })
                    // send data END
                } else {
                    // scrool to top id content_purchase
                    setTimeout(() => {
                        const elmnt = document.getElementsByClassName('error--text')[0];
                        const containerCard = document.getElementById('content_purchase');
                        if (elmnt && containerCard) {
                            const offset = 80;
                            const elementOffsetTop = elmnt.offsetTop;
                            containerCard.scrollTo({
                                top: elementOffsetTop - offset,
                                behavior: 'smooth'
                            });
                        }
                    }, 300);
                    
                    // notify
                    this.$notify.error('Campos requeridos vacios')
                }
            },
            clearData() {
                this.deliveryMethod = 'delivery'
                this.address = ''
                this.lng = ''
                this.lat = ''
                this.deliveryAddress = ''
                this.addressClarification = ''
                this.addressOfPickUp = ''
                this.receiveOrder = 'right_now'
                this.orderDay = null
                this.orderTime = null
                this.fullName = ''
                this.phoneNumber = ''
                this.paymentMethod = 'cash_payment'
                this.proofPayment = null
                this.remarkOrder = false
                this.commentOrder = ''
                this.createAccount = false
                this.password = ''
                this.e1 = 1

                // this.$refs.valFirst.resetValidation()
                // this.$refs.valLast.resetValidation()

                this.$emit('send-success')

                localStorage.removeItem(this.slug)
            },
            /**
             * preview order
             */
            openPreviewOrder() {
                if (this.$refs.valLast.validate()) {
                    // console.log('hello');
                    var tmpAddress25 = ''
                    if (this.deliveryMethod == 'delivery') {
                        tmpAddress25 = `Ver mapa: https://www.google.com/maps/place/${this.lat},${this.lng}, Dirección: ${this.deliveryAddress}, Más detalles: ${this.addressClarification}`
                    }
                    if (this.deliveryMethod == 'i_pick_up') {
                        tmpAddress25 = this.addressOfPickUp
                    }

                    var tmpPayment25 = '';
                    switch (this.paymentMethod) {
                        case 'cash_payment':
                            tmpPayment25 = "Pago Contraentrega";
                            break;
                        case 'bank_payment':
                            tmpPayment25 = "Pago Qr/Transferencia Bancaria";
                            break;
                        case 'card_payment':
                            tmpPayment25 = "Pago tarjeta de débito/crédito";
                            break;
                        case 'bank_ven':
                            tmpPayment25 = "Pago por PagomóvilBDV";
                            break;
                        default:
                            break;
                    }

                    var tmpDetails = ''
                    for (var [key, value] of Object.entries(this.cart)) {
                        var tmpComplements = this.cart[key].complements
                        this.cart[key].complementsDetails = ''
                        if (tmpComplements.multi.length > 0) {
                            tmpComplements.multi.forEach(element => {
                                this.cart[key].complementsDetails += element.split(':')[2]+'x'
                                this.cart[key].complementsDetails += element.split(':')[0]
                                this.cart[key].complementsDetails += ', '
                            });
                        }
                        if (tmpComplements.only.length > 0) {
                            tmpComplements.only.forEach(element => {
                                this.cart[key].complementsDetails += element.split(':')[0]
                                this.cart[key].complementsDetails += ', '
                            });
                        }
                    }

                    var subtotal = 0
                    for (const i in this.cart) {
                        const item = this.cart[i]
                        tmpDetails += `- ${item.quantity}x ${item.name}, ${item.complementsDetails} ${item.price}${this.money}, ${item.extra}\n`
                        subtotal += (+item.price)
                    }
                    var tempInvoices = (this.enableInvoice)?`DATOS DE FACTURACIÓN
Razón social: ${this.businessName}
Nit/Ci: ${this.document}`:'';

                    const fidelyPoiints = this.fidelyPoints ? `Puntos de fidelidad: ${this.fidelyPointsValue}, visita el programa de puntos aquí ${this.fidelyPointsUrl} gracias.` : '';

// generate text
this.contentOrder = `CLIENTE
Nombre: ${this.fullName}
Celular: ${this.phoneNumber}

DETALLES
Forma de entrega: ${ (this.deliveryMethod == 'i_pick_up')?'Recojo':(this.deliveryMethod == 'delivery') ? 'Delivery':'Pedido para la mesa' }
Recibir la orden: ${ (this.receiveOrder == 'schedule_delivery') ? 'Fecha: '+this.orderDay+' Hora: '+this.orderTime : 'Ahora mismo' }
${ (this.deliveryMethod == 'i_pick_up') ? 'Dirección de recojo' : 'Dirección de entrega' }: ${tmpAddress25}
Método de pago: ${tmpPayment25}

ARTÍCULOS
${tmpDetails}
Subtotal ${subtotal.toFixed(1)}${this.money}
Descuento ${(this.valCoupon+this.discountProds).toFixed(1)}${this.money}
${(this.eatLocal.enable && this.deliveryMethod=='eat_local') ? `Desc. comer en local -${(((this.total-this.valCoupon)>0)?( ((this.total-this.valCoupon)*this.eatLocal.value)/100 ).toFixed(0):0)}` : ''} ${this.money}
${(this.deliveryMethod == 'delivery') ? 'Delivery '+((this.tempPrice<=0)?'Por Confirmar':this.tempPrice+' '+this.money)+'' : ''} ${this.tempCommentDelivery!='' ? '- '+this.tempCommentDelivery : ''}
<strong>TOTAL ${(this.deliveryMethod == 'delivery') ? ""+((this.total+(+this.tempPrice))-(((this.valCoupon+this.discountProds)>0)?(this.valCoupon+this.discountProds):0))+""+this.money+"" : ""+(((this.total-(this.valCoupon+this.discountProds))>0)?( (this.total-(this.valCoupon+this.discountProds)) - (( ((this.total-(this.valCoupon+this.discountProds))*this.eatLocal.value)/100 ).toFixed(0)) ):0)+""+this.money+""} </strong>
${(this.remarkOrder) ? this.commentOrder : ''}
${tempInvoices}
${fidelyPoiints}`
// end
                    /**para acortar los pasos se elimino la opcion de vista previs y se llama directo a lastStep */
                    // this.dialogGenerate = true //descomentar si se desea mostrar vista previa
                    this.lastStep() //comentar si se desea mostrar vista previa
                } else {
                    // scrool to top id content_purchase
                    setTimeout(() => {
                        const elmnt = document.getElementsByClassName('error--text')[0];
                        const containerCard = document.getElementById('content_purchase');
                        if (elmnt && containerCard) {
                            const offset = 80;
                            const elementOffsetTop = elmnt.offsetTop;
                            containerCard.scrollTo({
                                top: elementOffsetTop - offset,
                                behavior: 'smooth'
                            });
                        }
                    }, 300);
                    
                    this.$notify.error('Campos requeridos vacios')
                }
            },
            sendOrderWhatsApp() {
                this.lastStep()
                // window.location.href = `https://wa.me/59161632421?text=${this.contentOrder}`
            }
        },
        computed: {
            numberDecimals () {
                return this.$store.state.numberDecimals.numberDecimals
            }
        }
    }
</script>
<style lang="scss">
.pa-actions {
    padding: 8px 16px;
    @media (max-width: 1020px) {
        padding: 12px 12px 50px 12px !important;
    }
}
</style>
